const SCI = require('sci')

const NEW_FORMS_SETTING = 'sci.settings.forms.use_new_forms'

const usesNewForms = () => {
    const instance = SCI.get('instance') || {}

    return (instance.overrides || {})[NEW_FORMS_SETTING] === true
}

module.exports = {
    NEW_FORMS_SETTING,
    usesNewForms
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/routes/forms/components/mixins/newFormsFlag.js